(function () {
  class OverlayDisplay extends PIXI.Container {
    constructor() {
      super();

      messageBus.subscribe('spinner:GameConfigEvent', this.onGameConfigEvent.bind(this));
      messageBus.subscribe('sidewinder:WildAddedEvent', this.onWildAdded.bind(this));
      messageBus.subscribe('sidewinder:SuperWildAddedEvent', this.onSuperWildAdded.bind(this));
      messageBus.subscribe('sidewinder:MegaWildAddedEvent', this.onMegaWildAdded.bind(this));
      messageBus.subscribe('sidewinder:BoostAddedEvent', this.onBoostAdded.bind(this));
      messageBus.subscribe('sidewinder:MysteryDataEvent', this.onMysterySymbolData.bind(this));
      messageBus.subscribe('sidewinder:XSymbolDataEvent', this.onXSymbolDataEvent.bind(this));
      Reflex.registerEventHandler('layoutChange', this.onLayoutChange.bind(this));
    }

    initialise() {
      this._overlayParent = undefined;
      this._xSymbol = undefined;
      this._mysteryIdleAnims = [];
      this._mysteryOpenAnims = [];
      this._electricSparkAnims = [];
      this._sparkleData = [];
      this._multiplierTrail = undefined;
      this._totalSparkleAnims = 0;
      this._sparkAnimsComplete = 0;
      this._mysteryPositions = [];
      this._shuffleMysteryAnims = [];
      this._isShuttersClosed = false;
      this._shuffleShutterPositions = [];
      this._sparklesPending = false;
      this._pendingSparkleCallback = undefined;
      this._xMovementTask = undefined;
      this._xMovementAnim = undefined;
      this._sparkAnimTask = undefined;
      this._storedXSymbol = undefined;
    }

    hideOnSpin() {
      this._hideMysteryAnimations();
      this.hideShuffleShutters();
      this.visible = false;
    }

    onSpinHit() {
      this.visible = true;
    }

    _hideMysteryAnimations() {
      // Hide all mysteryOpen animations on spin start
      for (let reel = 0; reel < 5; reel++) {
        for (let row = 0; row < 3; row++) {
          this._mysteryOpenAnims[reel][row].visible = false;
          this._mysteryOpenAnims[reel][row].gotoAndStop(0);

          this._mysteryIdleAnims[reel][row].visible = false;
          this._mysteryIdleAnims[reel][row].gotoAndStop(0);
        }
      }
      // Hide mystery backing animations on spin start
      if (this._symBackgroundAnimDisplay) {
        this._symBackgroundAnimDisplay.hideMysteryBacking();
      }
    }

    onGameConfigEvent() {
      this._overlayParent = resourceManager.get(this.name + ':overlayContainer');

      // Create all shutter animations (mysteryIdle, mysteryOpen, shuffleMystery)
      for (let reel = 0; reel < 5; reel++) {
        let idleAnims = [];
        let openAnims = [];
        let shuffleAnims = [];

        for (let row = 0; row < 3; row++) {
          const mysteryIdle = resourceManager.createObject(
            'movie',
            'mysteryIdleAnim' + reel + '_' + row,
            this._overlayParent.name,
            {
              definition: 'mysteryIdle',
              x: 0,
              y: 0,
              anchor: 0.5,
              loop: false,
            }
          );
          mysteryIdle.gotoAndStop(0);
          mysteryIdle.visible = false;
          idleAnims.push(mysteryIdle);

          const mystery = resourceManager.createObject(
            'movie',
            'mysteryAnim' + reel + '_' + row,
            this._overlayParent.name,
            {
              definition: 'mysteryOpen',
              x: 0,
              y: 0,
              anchor: 0.5,
              loop: false,
            }
          );
          mystery.gotoAndStop(0);
          mystery.visible = false;
          openAnims.push(mystery);

          // Create shuffle-specific mystery animations
          const shuffleMystery = resourceManager.createObject(
            'movie',
            'shuffleMysteryAnim' + reel + '_' + row,
            this._overlayParent.name,
            {
              definition: 'mysteryOpen',
              x: 0,
              y: 0,
              anchor: 0.5,
              loop: false,
            }
          );
          shuffleMystery.gotoAndStop(34);
          shuffleMystery.visible = false;
          shuffleAnims.push(shuffleMystery);
        }
        this._mysteryIdleAnims.push(idleAnims);
        this._mysteryOpenAnims.push(openAnims);
        this._shuffleMysteryAnims.push(shuffleAnims);
      }

      // Create all sparkle emitters AFTER the shutters, so they render over them
      for (let i = 0; i < 15; i++) {
        const sparkle = particleManager.createEmitter('electricTrail', this._overlayParent.name, 0, 0, false);
        sparkle.particleEmitter.blendMode = PIXI.BLEND_MODES.ADD;
        sparkle.particleEmitter.emit = false;
        sparkle.visible = false;
        this._electricSparkAnims.push(sparkle);
      }

      this._xSymbol = resourceManager.createObject('sprite', 'xSymbol', this._overlayParent.name, {
        fileName: 'slots/symbols/X/X.png',
        anchor: 0.5,
        x: 200,
        y: 200,
      });
      this._xSymbol.visible = false;

      this._xSymbolAnim = resourceManager.createObject('movie', 'xSymbolAnim', this._overlayParent.name, {
        definition: 'XSymbolAnim',
        x: 200,
        y: 200,
        anchor: 0.5,
        loop: true,
      });
      this._xSymbolAnim.gotoAndStop(0);
      this._xSymbolAnim.visible = false;

      this._multiplierTrail = resourceManager.get('multiplierTrailWrapper:multiplierTrail:multiplierTrail');

      // Get reference to symBackgroundAnimDisplay for mysteryBacking animations
      this._symBackgroundAnimDisplay = resourceManager.get(
        'slotContainer:reelContainer:symBackgroundAnimContainer:symBackgroundAnimDisplay'
      );

      this.onLayoutChange();
    }

    onWildAdded(task) {
      this._sparkleData = [];
      const coord = task.data.coord;

      const sparkle = {
        reel: coord.reel,
        row: coord.row,
        sym: coord.symId,
      };
      this._sparkleData.push(sparkle);
      this._sparklesPending = true;
    }

    onSuperWildAdded(task) {
      this._sparkleData = [];
      const coord = task.data.coord;

      for (let i = 0; i < 3; i++) {
        const sparkle = {
          reel: coord.reel,
          row: i,
          sym: coord.symId,
        };
        this._sparkleData.push(sparkle);
      }
      this._sparklesPending = true;
    }

    onMegaWildAdded(task) {
      this._sparkleData = [];
      const coord = task.data.coord;

      for (let i = 0; i < 3; i++) {
        const sparkle = {
          reel: coord.reel,
          row: i,
          sym: coord.symId,
        };
        this._sparkleData.push(sparkle);
      }
      this._sparklesPending = true;
    }

    onBoostAdded(task) {
      this._sparkleData = [];
      const boost = task.data.boostData;

      for (let i = 0; i < boost.coords.length; i++) {
        const sparkle = {
          reel: boost.coords[i].reel,
          row: boost.coords[i].row,
          sym: boost.newSym,
        };
        this._sparkleData.push(sparkle);
      }
      this._sparklesPending = true;
    }

    startSparkleAnims() {
      this._totalSparkleAnims = this._sparkleData.length;
      this._sparkAnimsComplete = 0;

      if (this._totalSparkleAnims > 1) {
        soundManager.play('spark_fly_multi');
      } else {
        soundManager.play('spark_fly');
      }

      for (let i = 0; i < this._totalSparkleAnims; i++) {
        this.startSparkle(this._sparkleData[i], i);
      }
    }

    /**
     * Trigger any pending sparkle animations.
     * Called by shuffle.js after the trail has filled to the correct level.
     * @param {function} callback - Called when all sparkles complete
     */
    triggerPendingSparkles(callback) {
      if (this._sparklesPending && this._sparkleData.length > 0) {
        this._pendingSparkleCallback = callback;
        this._sparklesPending = false;
        this.startSparkleAnims();
      } else if (callback) {
        callback();
      }
    }

    startSparkle(data, index) {
      const startPos = this._multiplierTrail.getCurrentTrailScreenPosition();
      const endPos = helpers.getSymbolPos(data.reel, data.row);
      const delay = index * 0.5;

      this._electricSparkAnims[index].position.set(startPos.x, startPos.y);
      this._electricSparkAnims[index].scale.set(0);
      this._electricSparkAnims[index].visible = true;
      this._electricSparkAnims[index].particleEmitter.emit = true;

      // JAMIE - sort out accurate positions later
      this._sparkAnimTask = gsap.to(this._electricSparkAnims[index], {
        x: endPos.x,
        y: endPos.y,
        duration: 1.0,
        delay: delay,
        ease: 'power1.inOut',
        onComplete: () => {
          this._electricSparkAnims[index].position.set(endPos.x, endPos.y);
          this.sparkleHit();
          this._sparkAnimTask = undefined;
        },
      });

      gsap.to(this._electricSparkAnims[index].scale, {
        x: 1,
        y: 1,
        duration: 0.25,
        delay: delay,
      });
    }

    sparkleHit(skip = false) {
      this._sparkAnimsComplete++;
      if (this._sparkAnimsComplete >= this._totalSparkleAnims || skip) {
        this.revealSparkles();
      }
    }

    revealSparkles() {
      let soundName = undefined;
      switch (this._sparkleData[0].sym) {
        case resourceManager.getConfiguration().symbols.Wild.ID:
          soundName = 'spark_wild_land';
          break;
        case resourceManager.getConfiguration().symbols.SuperWild.ID:
          soundName = 'spark_superwild_land';
          break;
        case resourceManager.getConfiguration().symbols.MegaWild_X2.ID:
        case resourceManager.getConfiguration().symbols.MegaWild_X3.ID:
        case resourceManager.getConfiguration().symbols.MegaWild_X5.ID:
          soundName = 'spark_megawild_land';
          break;
        default:
          break;
      }

      for (let i = 0; i < this._sparkleData.length; i++) {
        gsap.to(this._electricSparkAnims[i].scale, {
          x: 2,
          y: 2,
          duration: 0.5,
          onComplete: () => {
            if (soundName != null && i === this._totalSparkleAnims - 1) {
              soundManager.play(soundName);
            }

            let reel = resourceManager.get('slotContainer:reelContainer:reel' + this._sparkleData[i].reel);
            reel.setReelSymbol(this._sparkleData[i].row, this._sparkleData[i].sym);

            // Hide a shutter if there is one at this position
            this.hideShutterAtPosition(this._sparkleData[i].reel, this._sparkleData[i].row);

            gsap.to(this._electricSparkAnims[i].scale, {
              x: 0,
              y: 0,
              duration: 0.5,
              onComplete: () => {
                this._electricSparkAnims[i].visible = false;
                this._electricSparkAnims[i].particleEmitter.emit = false;
                this._electricSparkAnims[i].scale.set(0);
              },
            });
          },
        });
      }
      const self = this;
      timerManager.addTimeout(1200, function () {
        if (self._pendingSparkleCallback) {
          const callback = self._pendingSparkleCallback;
          self._pendingSparkleCallback = undefined;
          callback();
        }
      });
    }

    onMysterySymbolData(task) {
      const self = this;
      const mysteryData = task.data.mysteryData;

      if (!mysteryData.positions.length) {
        return;
      }

      task.join();

      // Store positions for layout change handling
      this._mysteryPositions = mysteryData.positions.slice();
      this._currentMysteryData = mysteryData;
      this._currentMysteryTask = task;

      // First play mysteryIdle animations
      for (let i = 0; i < mysteryData.positions.length; i++) {
        let reel = mysteryData.positions[i].reel;
        let row = mysteryData.positions[i].row;
        this._mysteryIdleAnims[reel][row].alpha = 1;
        this._mysteryIdleAnims[reel][row].visible = true;
        this._mysteryIdleAnims[reel][row].gotoAndPlay(0);
      }

      timerManager.addTimeout(1000, function () {
        self.mysteryIdleComplete();
      });
    }

    mysteryIdleComplete() {
      const self = this;
      const mysteryData = this._currentMysteryData;
      const task = this._currentMysteryTask;

      // Hide mysteryIdle and play mysteryOpen
      if (mysteryData.positions.length > 1) {
        soundManager.play('mysteryOpen');
      }

      for (let i = 0; i < mysteryData.positions.length; i++) {
        let reelIndex = mysteryData.positions[i].reel;
        let row = mysteryData.positions[i].row;

        this._mysteryIdleAnims[reelIndex][row].visible = false;
        this._mysteryIdleAnims[reelIndex][row].gotoAndStop(0);

        const reel = resourceManager.get('slotContainer:reelContainer:reel' + mysteryData.positions[i].reel);
        reel.setReelSymbol(mysteryData.positions[i].row, mysteryData.symbol);

        this._mysteryOpenAnims[reelIndex][row].alpha = 1;
        this._mysteryOpenAnims[reelIndex][row].visible = true;
        this._mysteryOpenAnims[reelIndex][row].gotoAndPlay(0);
      }

      // Store totalWinnings for shake trigger after shutters fully open
      this._pendingShakeTotalWinnings = task.data.totalLineWinnings || 0;

      if (this._symBackgroundAnimDisplay) {
        this._symBackgroundAnimDisplay.showMysteryBacking(mysteryData.positions);
      }

      timerManager.addTimeout(1200, function () {
        self.mysteryOpenComplete(task);
      });
    }

    mysteryOpenComplete(task) {
      // Shutters remain visible at final frame - no fade out
      this._mysteryPositions = [];

      // Trigger shake after shutters have fully opened
      const totalWinnings = this._pendingShakeTotalWinnings || 0;
      const reelsShaker = resourceManager.get('reelsShaker');
      const frameShaker = resourceManager.get('frameShaker');
      if (reelsShaker) reelsShaker.triggerShake(totalWinnings);
      if (frameShaker) frameShaker.triggerShake(totalWinnings);
      this._pendingShakeTotalWinnings = 0;

      task.leave();
    }

    onXSymbolDataEvent(task) {
      task.join();
      this._xMovementTask = task;
      const symData = task.data.xSymbolData;
      const reelPos = helpers.getSymbolPos(symData.reel, symData.row);
      this._xSymbol.visible = false;
      this._xSymbolAnim.x = reelPos.x + gameController.xSymbolPositionOffset.x;
      this._xSymbolAnim.y = reelPos.y + gameController.xSymbolPositionOffset.y;
      this._xSymbolAnim.scale.set(gameController.xSymbolScale);
      this._xSymbolAnim.gotoAndPlay(0);
      this._xSymbolAnim.visible = true;

      const reel = resourceManager.get('slotContainer:reelContainer:reel' + symData.reel);

      // Check if X symbol position matches a mystery shutter position
      // If it does make sure to switch back to the revealed symbol instead of the shutters
      let symbolToRestore = symData.oldSym;
      if (this._currentMysteryData && this._currentMysteryData.positions) {
        const isOnMysteryPosition = this._currentMysteryData.positions.some(
          (pos) => pos.reel === symData.reel && pos.row === symData.row
        );
        if (isOnMysteryPosition) {
          // Don't think this is needed anymore because the x symbol should animate off the shutter symbol
          // X Symbols should always be processed first
          //symbolToRestore = this._currentMysteryData.symbol;
        }
      }
      reel.setReelSymbol(symData.row, symbolToRestore);
      this._storedXSymbol = {
        reel: symData.reel,
        row: symData.row,
        sym: symbolToRestore,
      };

      const finalPos = this._multiplierTrail.getCurrentTrailScreenPosition();

      // Pulse animation to highlight the X symbol before moving to trail
      const pulseScale = gameController.xSymbolScale * 1.3;
      const pulseDuration = 0.3;
      const pulseDelay = 0.2;

      const pulseTimeline = gsap.timeline({
        delay: pulseDelay,
        onStart: () => {
          soundManager.play('multiplierPulse');
        },
        onComplete: () => {
          // After pulse completes, animate to trail
          this._animateXSymbolToTrail(finalPos, task);
        },
      });

      pulseTimeline
        .to(this._xSymbolAnim.scale, {
          x: pulseScale,
          y: pulseScale,
          duration: pulseDuration,
          ease: 'power2.out',
        })
        .to(this._xSymbolAnim.scale, {
          x: gameController.xSymbolScale,
          y: gameController.xSymbolScale,
          duration: pulseDuration,
          ease: 'power2.in',
        })
        .to(this._xSymbolAnim.scale, {
          x: pulseScale,
          y: pulseScale,
          duration: pulseDuration,
          ease: 'power2.out',
        })
        .to(this._xSymbolAnim.scale, {
          x: gameController.xSymbolScale,
          y: gameController.xSymbolScale,
          duration: pulseDuration,
          ease: 'power2.in',
        });
    }

    /**
     * Animate the X symbol from its current position to the multiplier trail
     * @param {Object} finalPos - Target position {x, y}
     * @param {Object} task - The task to leave when complete
     */
    _animateXSymbolToTrail(finalPos, task) {
      this._xSymbol.visible = false;

      // Bit of a hack, but if a skip is pressed after symbols have swapped, a belt and bracers check
      // will revert the symbol back to the variant with the x on it, so reseting it again here
      if (this._storedXSymbol) {
        const reel = resourceManager.get('slotContainer:reelContainer:reel' + this._storedXSymbol.reel);
        reel.setReelSymbol(this._storedXSymbol.row, this._storedXSymbol.sym);
        this._storedXSymbol = undefined;
      }

      gsap.to(this._xSymbolAnim.scale, {
        x: 1,
        y: 1,
        duration: 0.8,
        onComplete: () => {
          gsap.to(this._xSymbolAnim.scale, {
            x: 0,
            y: 0,
            duration: 0.2,
            onComplete: () => {
              this._xSymbolAnim.scale.set(0);
              this._xSymbolAnim.visible = false;
              this._xSymbolAnim.gotoAndStop(0);
            },
          });
        },
      });

      // JAMIE - sort out accurate positions later
      soundManager.play('multiplierMoveToTrail');
      this._xMovementAnim = gsap.to(this._xSymbolAnim, {
        x: finalPos.x - 44,
        y: finalPos.y,
        duration: 1.0,
        ease: 'power2.inOut',
        onComplete: () => {
          soundManager.play('multiplierLandOnTrail');
          this._xSymbolAnim.position.set(finalPos.x - 44, finalPos.y);
          soundManager.play('multiplierTrailLevelIncrease');
          this._multiplierTrail.shiftPanelsDown();
          task.leave();
        },
      });
    }

    onLayoutChange() {
      const slotContainer = resourceManager.get('slotContainer');
      const scale = slotContainer.scale.x;

      if (this._sparkAnimTask) {
        this._sparkAnimTask.kill();
        this._sparkAnimTask = undefined;

        for (let i = 0; i < this._electricSparkAnims.length; i++) {
          this._electricSparkAnims[i].scale.set(0);
          this._electricSparkAnims[i].visible = false;
          this._electricSparkAnims[i].particleEmitter.emit = false;
        }

        this.sparkleHit(true);
      }

      if (this._xMovementAnim && this._xMovementAnim.isActive()) {
        this._xSymbol.visible = false;

        this._xMovementAnim.totalProgress(1);
        this._xSymbolAnim.gotoAndStop(0);
        this._xSymbolAnim.visible = false;
        this._xSymbolAnim.scale.set(gameController.xSymbolScale);
      }

      for (let reel = 0; reel < this._mysteryIdleAnims.length; reel++) {
        for (let row = 0; row < this._mysteryIdleAnims[0].length; row++) {
          const reelPos = helpers.getSymbolPos(reel, row);
          this._mysteryIdleAnims[reel][row].position.set(reelPos.x, reelPos.y);
          this._mysteryIdleAnims[reel][row].scale.set(scale);

          this._mysteryOpenAnims[reel][row].position.set(reelPos.x, reelPos.y);
          this._mysteryOpenAnims[reel][row].scale.set(scale);

          this._shuffleMysteryAnims[reel][row].position.set(reelPos.x, reelPos.y);
          this._shuffleMysteryAnims[reel][row].scale.set(scale);
        }
      }
    }

    /**
     * Close shutters before shuffle animation (play mysteryOpen in reverse)
     */
    closeShuttersForShuffle(positions, callback) {
      const self = this;
      const TOTAL_FRAMES = 35;
      const FPS = 30;
      const TOTAL_DURATION = (TOTAL_FRAMES / FPS) * 1000;

      // Hide any existing mystery backing animations before shuffle
      if (this._symBackgroundAnimDisplay) {
        this._symBackgroundAnimDisplay.hideMysteryBacking();
      }

      if (!positions || positions.length === 0) {
        if (callback) callback();
        return;
      }

      this._shuffleShutterPositions = positions.slice();

      // Position and show animations at final frame (open state)
      for (let i = 0; i < positions.length; i++) {
        let reel = positions[i].reel;
        let row = positions[i].row;
        this._shuffleMysteryAnims[reel][row].alpha = 1;
        this._shuffleMysteryAnims[reel][row].visible = true;
        this._shuffleMysteryAnims[reel][row].gotoAndStop(TOTAL_FRAMES - 1);
      }

      // Animate in reverse using timerManager
      soundManager.play('mysteryClose');
      timerManager.addTimer(
        TOTAL_DURATION,
        function (progress) {
          const frame = Math.floor((1 - progress) * (TOTAL_FRAMES - 1));
          for (let i = 0; i < positions.length; i++) {
            let reel = positions[i].reel;
            let row = positions[i].row;
            self._shuffleMysteryAnims[reel][row].gotoAndStop(frame);
          }
        },
        function () {
          for (let i = 0; i < positions.length; i++) {
            let reel = positions[i].reel;
            let row = positions[i].row;
            self._shuffleMysteryAnims[reel][row].gotoAndStop(0);
          }
          self._isShuttersClosed = true;
          self._hideMysteryAnimations();
          if (callback) callback();
        }
      );
    }

    /**
     * Open shutters after shuffle animation (play mysteryOpen forward)
     */
    openShuttersAfterShuffle(positions, symbol, callback) {
      const self = this;
      const TOTAL_FRAMES = 35;
      const FPS = 30;
      const TOTAL_DURATION = (TOTAL_FRAMES / FPS) * 1000;
      const IDLE_DURATION = 1000; // Match regular mystery flow timing

      if (!positions || positions.length === 0) {
        this._isShuttersClosed = false;
        if (callback) callback();
        return;
      }

      this._shuffleShutterPositions = positions.slice();

      // Hide shuffleMysteryAnims so idle animations are visible (they render on top due to z-order)
      for (let reel = 0; reel < 5; reel++) {
        for (let row = 0; row < 3; row++) {
          this._shuffleMysteryAnims[reel][row].visible = false;
        }
      }

      // First play mysteryIdle animations (matching regular mystery flow)
      for (let i = 0; i < positions.length; i++) {
        let reel = positions[i].reel;
        let row = positions[i].row;
        this._mysteryIdleAnims[reel][row].alpha = 1;
        this._mysteryIdleAnims[reel][row].visible = true;
        this._mysteryIdleAnims[reel][row].gotoAndPlay(0);
      }

      // After idle completes, proceed with shutter opening
      timerManager.addTimeout(IDLE_DURATION, function () {
        // Hide idle animations
        for (let i = 0; i < positions.length; i++) {
          let reel = positions[i].reel;
          let row = positions[i].row;
          self._mysteryIdleAnims[reel][row].visible = false;
          self._mysteryIdleAnims[reel][row].gotoAndStop(0);
        }

        // Update symbols on shuffle reels to the new mystery reveal symbol
        for (let i = 0; i < positions.length; i++) {
          const shuffleReel = resourceManager.get(
            'slotContainer:reelContainer:reelsForShuffling:reelBackerReel' +
              positions[i].reel +
              ':reel' +
              positions[i].reel
          );
          if (shuffleReel) {
            shuffleReel.setReelSymbol(positions[i].row, symbol);
            shuffleReel.update();
          }

          // Position animations at frame 0 (closed state)
          let reel = positions[i].reel;
          let row = positions[i].row;
          self._shuffleMysteryAnims[reel][row].alpha = 1;
          self._shuffleMysteryAnims[reel][row].visible = true;
          self._shuffleMysteryAnims[reel][row].gotoAndStop(0);
        }

        // Animate forward
        soundManager.play('mysteryOpen');
        timerManager.addTimer(
          TOTAL_DURATION,
          function (progress) {
            const frame = Math.floor(progress * (TOTAL_FRAMES - 1));
            for (let i = 0; i < positions.length; i++) {
              let reel = positions[i].reel;
              let row = positions[i].row;
              self._shuffleMysteryAnims[reel][row].gotoAndStop(frame);
            }
          },
          function () {
            for (let i = 0; i < positions.length; i++) {
              let reel = positions[i].reel;
              let row = positions[i].row;
              self._shuffleMysteryAnims[reel][row].gotoAndStop(TOTAL_FRAMES - 1);
            }
            self._isShuttersClosed = false;

            // Play mystery backing animation behind revealed symbols
            if (self._symBackgroundAnimDisplay) {
              self._symBackgroundAnimDisplay.showMysteryBacking(positions);
            }
            if (callback) callback();
          }
        );
      });
    }

    /**
     * Show closed shutters (for covering symbols before open animation)
     */
    showClosedShuttersAtPositions(positions) {
      if (!positions || positions.length === 0) return;

      for (let i = 0; i < positions.length; i++) {
        let reel = positions[i].reel;
        let row = positions[i].row;
        this._shuffleMysteryAnims[reel][row].gotoAndStop(0);
        this._shuffleMysteryAnims[reel][row].alpha = 1;
        this._shuffleMysteryAnims[reel][row].visible = true;
      }
    }

    /**
     * Hide all shuffle shutter animations and reset
     */
    hideShuffleShutters() {
      for (let reel = 0; reel < 5; reel++) {
        for (let row = 0; row < 3; row++) {
          this._shuffleMysteryAnims[reel][row].visible = false;
          this._shuffleMysteryAnims[reel][row].alpha = 1;
        }
      }

      this._shuffleShutterPositions = [];
      this._isShuttersClosed = false;
    }

    /**
     * Hide shutter at a specific position
     * @param {number} reel - The reel index
     * @param {number} row - The row index
     */
    hideShutterAtPosition(reel, row) {
      for (let i = 0; i < this._shuffleShutterPositions.length; i++) {
        const pos = this._shuffleShutterPositions[i];
        if (pos.reel === reel && pos.row === row) {
          this._shuffleMysteryAnims[reel][row].visible = false;
          break;
        }
      }
    }
  }

  let creator = function () {
    return new OverlayDisplay();
  };

  let filesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType('overlayDisplay', creator, initialise, filesRequired);
})();
